import { RSAA } from 'redux-api-middleware'
import { getApiPath, makeQueryParams } from 'sidecar-utility-library'

import { types, initialState } from 'store/Guarantees'

/**
 * @param {string} accountUuid - Account we want to get guarantees for
 * @param {string} memberUuid - Member we want to get guarantees for
 * @returns
 */
export const fetchGuarantees = ({ accountUuid, memberUuid }) => ({
  [RSAA]: {
    endpoint: getApiPath(
      'care',
      `cares/locked-bundles${makeQueryParams({
        accountUuid,
        memberUuid,
      })}`,
    ),
    method: 'GET',
    types: [
      types.FETCH_GUARANTEES_REQUEST,
      types.FETCH_GUARANTEES_SUCCESS,
      types.FETCH_GUARANTEES_ERROR,
    ],
  },
})

export const fetchGuaranteesCount = ({ accountUuid, memberUuid }) => ({
  [RSAA]: {
    endpoint: getApiPath(
      'care',
      `cares/locked-bundles/count${makeQueryParams({ accountUuid, memberUuid })}`,
    ),
    method: 'GET',
    types: [
      types.FETCH_GUARANTEES_REQUEST,
      types.FETCH_GUARANTEES_COUNT_SUCCESS,
      types.FETCH_GUARANTEES_ERROR,
    ],
  },
})

export default (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case types.FETCH_GUARANTEES_REQUEST:
      return {
        ...state,
        guarantees: {
          ...state.guarantees,
          busy: true,
          error: null,
        },
      }

    case types.FETCH_GUARANTEES_COUNT_SUCCESS: {
      const { totalActiveBundles } = payload
      return {
        ...state,
        guarantees: {
          ...state.guarantees,
          busy: false,
          count: totalActiveBundles,
        },
      }
    }

    case types.FETCH_GUARANTEES_SUCCESS:
      return {
        ...state,
        guarantees: {
          ...state.guarantees,
          busy: false,
          entities: payload,
        },
      }

    case types.FETCH_GUARANTEES_ERROR:
      return {
        ...state,
        guarantees: {
          ...state.guarantees,
          busy: false,
          error: payload?.response?.message,
        },
      }

    default:
      return state
  }
}
